/**
 * @module ScriptLoader
 */
class ScriptLoader {

    /**
     * The contrustor
     */
    constructor() {
        this._scripts = new Map();
    }

    /**
     * Load a script with given src
     * @param {String} source - The source to load
     * @returns {Promise} - Returns a promise
     */
    load(source) {
        if (this._scripts.has(source)) {
            return this._scripts.get(source);
        }

        const script = new Promise((resolve, reject) => {
            const tag = document.createElement('script');

            tag.src = source;
            tag.onload = resolve;
            tag.onerror = reject;

            document.body.appendChild(tag);
        });

        this._scripts.set(source, script);

        return script;
    }
}

export default new ScriptLoader();
